import {slideToggle} from "../utilities/u-accordion";
import {convertCssAniDurationToMS} from "../utilities/helper-function";

class FooterNavigation {
    constructor(element) {
        this.element = element;
        this.footerNavigationBtns = this.element.querySelectorAll('button.footer__navigation-btn');
        this.btnFirstLevel = this.element.querySelectorAll('.footer__navigation-btn--level-1');
        this.secondLevelLists = this.element.querySelectorAll('.footer__navigation--2nd-level');
        this.resizeTimeout = null;

        this.rootStyles = getComputedStyle(document.documentElement);
        this.aniFast= convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--fast').trim());
        this.aniSlow= convertCssAniDurationToMS(this.rootStyles.getPropertyValue('--ani--slow').trim());

        this.breakpoint = 768;

        if (!this.isWindowMobileSize()) {
            this.disableButtons();
        }

        /* Event Listeners */
        this.footerNavigationBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                if (this.isButtonSelected(btn)) {
                    this.toggleCurrentBtnStatus(btn, true);
                    this.togglePanelLayerVisibility(btn.nextElementSibling);

                    if (this.isWindowMobileSize()) {
                        this.addClassForCloseAnimation(btn.nextElementSibling, "footer__navigation-list--hide", this.aniSlow);
                    }

                } else {
                    this.clearCurrentlySelectedSiblingsStyles(btn);
                    this.toggleCurrentBtnStatus(btn, false);
                    this.togglePanelLayerVisibility(btn.nextElementSibling);
                }
            });
        });

        window.addEventListener('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.onResize();
            }, 10);
        });
    }


    toggleCurrentBtnStatus(btn, isButtonSelected) {
        btn.classList.toggle('footer__navigation-btn--current');
        btn.setAttribute('aria-expanded', !isButtonSelected);
    }

    togglePanelLayerVisibility(panelLayer) {
        panelLayer.classList.toggle('footer__navigation-list--show');

        if (this.isWindowMobileSize(panelLayer)) {
            slideToggle(panelLayer, this.aniSlow);
        }
    }

    clearCurrentlySelectedSiblingsStyles(btn) {
        const parentList = btn.closest('.footer__navigation-list');
        const currentSelectedBtns = parentList.querySelectorAll('.footer__navigation-btn--current');
        currentSelectedBtns.forEach((selectedBtn) => {
            this.toggleCurrentBtnStatus(selectedBtn, true);
            this.togglePanelLayerVisibility(selectedBtn.nextElementSibling);
        })
    }

    /* Helper Functions */

    isButtonSelected(btn) {
        return btn.classList.contains('footer__navigation-btn--current');
    }

    isWindowMobileSize() {
        return window.innerWidth < this.breakpoint;
    }

    addClassForCloseAnimation(element, classForAnima, animationTime) {
        element.classList.add(classForAnima);
        setTimeout(() => {
            element.classList.remove(classForAnima);
        }, animationTime);
    }

    onResize() {
        if (!this.isWindowMobileSize()) {
            this.secondLevelLists.forEach((list) => {
                list.removeAttribute('style');
            });

            this.btnFirstLevel.forEach((btn) => {
                btn.removeAttribute('aria-expanded');
                if(btn.classList.contains('footer__navigation-btn--current')) {
                    btn.classList.remove('footer__navigation-btn--current');
                    btn.nextElementSibling.classList.remove('footer__navigation-list--show');
                }
            });

            this.disableButtons();
        } else {
            this.btnFirstLevel.forEach((btn) => {
                btn.setAttribute('aria-expanded', false);
            });
            this.enableButtons();
        }
    }

    disableButtons() {
        this.btnFirstLevel.forEach((btn) => {
            btn.setAttribute("disabled", true);
        });
    }

    enableButtons() {
        this.btnFirstLevel.forEach((btn) => {
            btn.removeAttribute("disabled");
        });
    }

}

export default FooterNavigation;